import axios from 'axios'
import React, { useEffect, useState } from 'react'
import Not_Found from './Not_Found'
import { json, useParams } from 'react-router-dom'
import BlogImage from '../Blogs_Icons/blog_resized_900_450_49_1639295414_types_ceiling_lamps (1).jpg'
import CalenderIcon from '../Logos/calendar.svg'
import PenIcon from '../Logos/pen-tool.svg'
import TagIcon from '../Logos/tag.svg'



function Blog() {
    const { BlogName } = useParams()
    const [BlogData, setBlogData] = useState()
    const [Title, SetTitle] = useState()
    const [Date, SetDate] = useState()
    const [Writer, SetWriter] = useState()
    const [Tags, SetTags] = useState([])
    const [Image, SetImage] = useState()
    const [MainDescription, SetMainDescription] = useState()
    const [Sections, SetSections] = useState([])
    useEffect(() => {
        axios.post("http://127.0.0.1:3001/select-blog", { BlogName })
            .then(data => {
                setBlogData(data.data[0])
                SetTitle(data.data[0].title)
                SetDate(data.data[0].date)
                SetWriter(data.data[0].writer)
                const TagsArrays = JSON.parse(data.data[0].tags)
                SetTags(TagsArrays)
                SetImage(data.data[0].thumbnail)
                SetMainDescription(data.data[0].main_description)
                const SectionsArrays = JSON.parse(data.data[0].sections)
                SetSections(SectionsArrays)
            })
            .catch(err => { console.log(err) })
    }, [])
    return (
        <>
            <main>
                {BlogData === "Not Found" || !BlogData ? <Not_Found /> : <div className='blog'>
                    <div className='title'>{Title ? Title : null}</div>
                    <div className='blog-details'>
                        <div className='blog-tags'>
                            <div className='tags'>تگ ها: {Tags ? Tags.map((items, key) => { return " | " + items }) : null}</div>
                            <img src={TagIcon} className='details-icon' alt='calender-icon' />
                        </div>
                        <div className='blog-writer'>
                            <div className='writer'>نویسنده: {Writer ? Writer : null}</div>
                            <img src={PenIcon} className='details-icon' alt='calender-icon' />
                        </div>
                        <div className='blog-date'>
                            <div className='date'>{Date}</div>
                            <img src={CalenderIcon} className='details-icon' alt='calender-icon' />
                        </div>
                    </div>
                    <div className='image-container'>
                        <img src={BlogImage} alt='blog-image' className='blog-image' />
                    </div>
                    <div className='main-description'>{MainDescription ? MainDescription : null}</div>
                    {Sections ? Sections.map((Items, key) => {
                        return <div className='description-section'>
                            <div className='description-title' style={{ color: Items.TitleColor }}>{Items.title}</div>
                            <div className='description'>{Items.description}</div>
                        </div>
                    }): null}
                </div>}

            </main>
        </>
    )
}

export default Blog